/**
 * eReg Layout Component
 *
 * Main layout wrapper with header, sidebar, and content area. Mounted ONCE
 * as a layout route (Phase 1 item 9) — pages render into the <Outlet/>, so
 * navigating between them no longer remounts the shell.
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex flex-col h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <Header onMenuClick={() => setSidebarOpen(true)} />

      {/* Main content area */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* Content */}
        <main className="flex-1 overflow-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-2 px-6 flex-shrink-0 dark:bg-gray-800 dark:border-gray-700">
        <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
          <span>eReg Document Management</span>
          <span>SiteOperations.io</span>
        </div>
      </footer>
    </div>
  );
}
